// extracted by mini-css-extract-plugin
module.exports = {"Upload":"Upload_Upload__1JKpn","Upload__list":"Upload_Upload__list__2Iuz9"};